import * as React from 'react';
import SVGIcon from '../SVGIcon';

// tslint:disable:max-line-length
const points =
  '2.64874552 0 1 1.64874552 9.35125448 10 1 18.3512545 2.64874552 20 11 11.6487455 19.3512545 20 21 18.3512545 12.6487455 10 21 1.64874552 19.3512545 0 11 8.35125448';
// tslint:enable:max-line-length

const MobileCloseIcon: React.FC = () => {
  return (
    <SVGIcon viewBox="0 0 22 20">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon stroke="#FFFFFF" fill="#FFFFFF" fillRule="nonzero" points={points} />
      </g>
    </SVGIcon>
  );
};

export default MobileCloseIcon;
